import React, { createContext, useContext } from 'react';
import useCoursePromoTriggers from '../hooks/useCoursePromoTriggers';

const CoursePromoContext = createContext(null);

export const CoursePromoProvider = ({ children }) => {
  const triggers = useCoursePromoTriggers();

  return (
    <CoursePromoContext.Provider value={triggers}>
      {children}
    </CoursePromoContext.Provider>
  );
};

export const useCoursePromo = () => {
  const context = useContext(CoursePromoContext);
  if (!context) {
    throw new Error('useCoursePromo must be used within CoursePromoProvider');
  }
  return context;
};

export default CoursePromoContext;
